import { memo } from "react";
import { useTranslation } from "react-i18next";
import styles from "./AppFeatures.module.css";

const AppFeatures = () => {
  const { t } = useTranslation();

  const cards = [
    {
      icon: "bi-journal-bookmark-fill",
      title: t("appFeatures.feat1Title", "Audio & Print Library"),
      desc: t("appFeatures.feat1Desc", "Browse and buy physical or audiobooks and listen directly inside the app."),
    },
    {
      icon: "bi-broadcast-pin",
      title: t("appFeatures.feat2Title", "24/7 Live Radio"),
      desc: t("appFeatures.feat2Desc", "Listen to continuous live radio streaming and cultural talk shows anytime."),
    },
    {
      icon: "bi-mic-fill",
      title: t("appFeatures.feat3Title", "Podcasts Hub"),
      desc: t("appFeatures.feat3Desc", "Follow live or recorded intellectual podcasts from top creators."),
    },
    {
      icon: "bi-shield-check",
      title: t("appFeatures.feat4Title", "Secure Authentication"),
      desc: t("appFeatures.feat4Desc", "Fast login verified via OTP or using Google and Apple accounts."),
    },
    {
      icon: "bi-truck",
      title: t("appFeatures.feat5Title", "Fast & Secure Delivery"),
      desc: t("appFeatures.feat5Desc", "Full shipping coverage and instant rates for Egypt and Saudi Arabia."),
    },
    {
      icon: "bi-bell-fill",
      title: t("appFeatures.feat6Title", "Push Notifications"),
      desc: t("appFeatures.feat6Desc", "Stay updated instantly on live shows, new episodes, and book releases."),
    },
  ];

  return (
    <section className={styles.sectionWrapper} id="app-features">
      <div className="container">
        <div className={`${styles.contentHeader} text-center`}>
          <span className={styles.subtitle}>
            {t("appFeatures.subtitle", "APP FEATURES")}
          </span>
          <h2 className={styles.title}>
            {t("appFeatures.title", "Designed for Contemporary Thinkers")}
          </h2>
        </div>

        <div className={styles.gridContainer}>
          {cards.map((card, index) => (
            <div key={index} className={styles.featureCard}>
              <div className={styles.iconWrapper}>
                <i className={`bi ${card.icon}`}></i>
              </div>
              <h3 className={styles.cardTitle}>{card.title}</h3>
              <p className={styles.cardDesc}>{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default memo(AppFeatures);
